export const decodeChainPacket = (
  response: Record<string, unknown>,
): Record<string, unknown> => {
  const decodeRecursive = (obj: unknown): unknown => {
    if (Array.isArray(obj)) {
      return obj.map(item => decodeRecursive(item));
    } else if (
      typeof obj === 'object' &&
      obj !== null &&
      '_type' in (obj as Record<string, unknown>)
    ) {
      switch ((obj as Record<string, unknown>)._type) {
        case 'date':
          return new Date((obj as Record<string, string>).data);
        case 'Uint8Array':
          return new Uint8Array(
            Buffer.from((obj as Record<string, string>).data, 'base64'),
          );
        case 'BigInt':
          return BigInt((obj as Record<string, string>).data);
        default:
          throw new Error(
            `Unknown type: ${(obj as Record<string, string>)._type}`,
          );
      }
    } else if (
      typeof obj === 'object' &&
      obj !== null &&
      !ArrayBuffer.isView(obj)
    ) {
      return Object.keys(obj).reduce(
        (acc, key) => {
          acc[key] = decodeRecursive((obj as Record<string, unknown>)[key]);
          return acc;
        },
        {} as Record<string, unknown>,
      );
    } else {
      return obj;
    }
  };

  return decodeRecursive(response) as Record<string, unknown>;
};

export const encodeChainPacket = (
  response: Record<string, unknown>,
): Record<string, unknown> => {
  const encodeRecursive = (obj: unknown): unknown => {
    if (Array.isArray(obj)) {
      return obj.map(item => encodeRecursive(item));
    } else if (
      typeof obj === 'object' &&
      obj !== null &&
      !ArrayBuffer.isView(obj)
    ) {
      return Object.keys(obj).reduce(
        (acc, key) => {
          acc[key] = encodeRecursive((obj as Record<string, unknown>)[key]);
          return acc;
        },
        {} as Record<string, unknown>,
      );
    } else {
      if (obj instanceof Date) {
        return {
          _type: 'date',
          data: obj.toISOString(),
        };
      }

      // check that is Uint8Array
      if (ArrayBuffer.isView(obj)) {
        switch (obj.constructor.name) {
          case 'Uint8Array': {
            return {
              _type: 'Uint8Array',
              data: Buffer.from(obj as Uint8Array).toString('base64'),
            };
          }

          default: {
            throw new Error(
              `Unknown ArrayBuffer type: ${obj.constructor.name}`,
            );
          }
        }
      }

      if (typeof obj === 'bigint') {
        return {
          _type: 'BigInt',
          data: obj.toString(),
        };
      }

      return obj;
    }
  };

  return encodeRecursive(response) as Record<string, unknown>;
};
